/* global $, URLSearchParams */

if ("bb" in window) {
  throw "bb was already loaded";
}
import "./lib/polyfills/url-search-params.js";
import * as Errors from "./lib/errors.js";
import { token } from "./lib/tokens.js";
import { shouldExit } from "./lib/case-exit.js";
import { A11y } from "./lib/a11y";
import { Ajax, checkJSON } from "./lib/ajax.js";
import { BBI } from "./lib/bbi.js";
import { collectWithin, serializeQuestions } from "./lib/collect-values.js";
import { conf, propFinder } from "./lib/conf";
import { wControl, getControl } from "./lib/control.js";
import { validateInput } from "./lib/control-validation.js";
import { parseDate, humanDate } from "./lib/dates";
import { escapeHTML } from "./lib/escape.js";
import {
  editPolicy,
  mustUpdate,
  canEditEarlier
} from "./lib/feature-queries.js";
import { createFormGroup } from "./lib/form-groups.js";
import "./lib/form-widgets-definitions.js";
import { setSettled } from "./lib/settled.js";
import { collectAttributes } from "./lib/utils";
import {
  any,
  both,
  complement,
  compose,
  either,
  find,
  has,
  ifElse,
  includes,
  map,
  path,
  pathEq,
  prop,
  propEq,
  propOr,
  tap,
  when
} from "./lib/functional";
import { doGrouping, groupOuter } from "./lib/groupings";
import { Jumplist } from "./lib/jumplist";
import { fromApiServer } from "./lib/location.js";
import { Mode } from "./lib/mode.js";
import { Numerals } from "./lib/numerals.js";
import { notify } from "./lib/notify.js";
import { permissions, webadminMakesSense } from "./lib/permissions.js";
import { _ } from "./lib/gettext.js";
import { positionalFormat } from "./lib/text-utils";
import { urlutils } from "./lib/url-utils.js";
import Vars from "./lib/vars.js";
import "./lib/$.scrollTo.js";

$("html").removeClass("no-js");

const arbitraryCoreProp = propFinder(conf, "arbitrary.core");
/**
 * Copyright (c) 2010 Conrad Irwin <conrad@rapportive.com> MIT license.
 * Based loosely on original: Copyright (c) 2008 mkmanning MIT license.
 *
 * Parses CGI query strings into javascript objects.
 *
 * See the README for details.
 **/
$.parseQuery = function (options) {
  var config = { query: window.location.search || "" },
    params = {};

  if (typeof options === "string") {
    options = { query: options };
  }
  $.extend(config, $.parseQuery, options);
  config.query = config.query.replace(/^\?/, "");

  $.each(config.query.split(config.separator), function (i, param) {
    var pair = param.split("="),
      key = config.decode(pair.shift(), null).toString(),
      value = config.decode(pair.length ? pair.join("=") : null, key);

    if (
      config.array_keys.test
        ? config.array_keys.test(key)
        : config.array_keys(key)
    ) {
      params[key] = params[key] || [];
      params[key].push(value);
    } else {
      params[key] = value;
    }
  });
  delete params[""];
  return params;
};
$.parseQuery.decode = $.parseQuery.default_decode = function (string) {
  return decodeURIComponent((string || "").replace(/\+/g, " "));
};
$.parseQuery.array_keys = function () {
  return false;
};
$.parseQuery.separator = "&";

// thanks http://web.enavu.com/daily-tip/maxlength-for-textarea-with-jquery/
$(document).on("keyup", "textarea[maxlength]", function () {
  var $this = $(this);
  //get the limit from maxlength attribute
  var limit = parseInt($this.prop("maxlength"));
  //get the current text inside the textarea
  var text = $this.val();
  //count the number of characters in the text
  var chars = text.length;

  //check if there are more characters then allowed
  if (chars > limit) {
    //and if there are use substr to get the text before the limit
    var new_text = text.substr(0, limit);

    //and change the current text with the new text
    $this.val(new_text);
    $this.addClass("bb-programmatically-changed");
    window.setTimeout(function () {
      $this.removeClass("bb-programmatically-changed");
    }, 1000);
  }
});

let bb = { Mode, conf };

/*** TEXT UTILITIES BEGIN ***/

/******* compareVersions ******/
function compareVersions(a, b) {
  var i, l, d;

  a = a.toLowerCase().split(/(\d+)/);
  b = b.toLowerCase().split(/(\d+)/);
  l = Math.min(a.length, b.length);

  for (i = 0; i < l; i++) {
    d = a[i] - b[i];
    if (isNaN(d)) {
      if (a[i] === b[i]) d = 0;
      else if (a[i] < b[i]) {
        d = -1;
      } else d = 1;
    }
    if (d !== 0) return d;
  }

  return a.length - b.length;
}

function compareVersionsOn(prop, a, b) {
  return compareVersions(String(a[prop]), String(b[prop]));
}
/*** TEXT UTILITIES END ***/

/*** DATEPICKER BEGIN ***/

// Defaults jQuery datepicker BEGIN
$(function () {
  $.datepicker.setDefaults(
    $.extend(
      true,
      $.datepicker._defaults,
      {
        showAnim: "",
        changeYear: true,
        changeMonth: true,
        yearRange: "c-150:c+150"
      }, // RFC
      arbitraryCoreProp("datepicker.defaults") || {},
      { altFormat: "yy-mm-dd" }
    )
  );
});
// Defaults jQuery datepicker END

/*** DATEPICKER END ***/

/*** MISC jQUERY UTILITIES BEGIN ***/

// thanks http://jqueryfordesigners.com/video.php?f=queue.flv
$.fn.pause = function (n) {
  return this.queue(function () {
    var el = this;
    window.setTimeout(function () {
      return $(el).dequeue();
    }, n);
  });
};

$.fn.sort = function () {
  return this.pushStack($.makeArray([].sort.apply(this, arguments)));
};

$.fn.extend({
  insertAtCaret: function (myValue) {
    return this.each(function () {
      if (document.selection) {
        //For browsers like Internet Explorer
        this.focus();
        var sel = document.selection.createRange();
        sel.text = myValue;
        this.focus();
      } else if (this.selectionStart || this.selectionStart == "0") {
        //For browsers like Firefox and Webkit based
        var startPos = this.selectionStart;
        var endPos = this.selectionEnd;
        var scrollTop = this.scrollTop;
        this.value =
          this.value.substring(0, startPos) +
          myValue +
          this.value.substring(endPos, this.value.length);
        this.focus();
        this.selectionStart = startPos + myValue.length;
        this.selectionEnd = startPos + myValue.length;
        this.scrollTop = scrollTop;
      } else {
        this.value += myValue;
        this.focus();
      }
      return this;
    });
  },
  selectAllText: function () {
    var el = this.get(0);
    if (el) {
      if (typeof el.selectionStart === "number") {
        (el.selectionStart = 0), (el.selectionEnd = el.value.length);
      } else if (typeof el.createTextRange !== "undefined") {
        el.focus();
        var range = el.createTextRange();
        range.select();
      }
    }
    return this;
  }
});

/** Add resizeEnd event.
 *
 * Thanks Carlos Martinez on
 * http://stackoverflow.com/questions/2854407/
 * javascript-jquery-window-resize-how-to-fire-after-the-resize-is-completed
 *
 * I did put this in a closure so as not to pollute the global
 * namespace.
 */
(function () {
  var _to = null,
    _delay = 500;
  $(window).on("resize", function () {
    if (_to) window.clearTimeout(_to);
    _to = window.setTimeout(function () {
      $(this).trigger("resizeEnd");
    }, _delay);
  });
})();
/*** MISC jQUERY UTILITIES END ***/

/*** KEYMAP BEGIN ***/
var KEYS = {
  BACKSPACE: 8,
  TAB: 9,
  ENTER: 13,
  SPACE: 32,
  ESC: 27,
  UP: 38,
  DOWN: 40,
  KP_RADIX: 110
};

// Navigation
var maps = {
  questions: function (ev) {
    if (!Mode.get("hasModel")) return undefined;
    if (ev.originalEvent.target && ev.originalEvent.target.tagName === "TR") {
      if (!gridKeys(ev)) return false;
    }
    var $target = $(ev.target);
    switch (ev.keyCode) {
      case KEYS.ENTER:
        if ($target.hasClass("bb-prior")) {
          step("prior");
          return false;
        }
        if ($target.hasClass("bb-skip")) {
          step("skip");
          return false;
        }
        if (!Mode.get("hasNoNext")) {
          if (
            ev.shiftKey ||
            $target.hasClass("bb-next") ||
            $target.is('input[type="text"]') ||
            $target.is('input[type="radio"]') ||
            $target.is('input[type="checkbox"]') ||
            $target.is('input[type="checkbox"]') ||
            $target.is('select[data-type="listbox"]') ||
            $target.is("fieldset")
          ) {
            step("next");
            return false;
          }
          if (ev.target.tagName === "TEXTAREA") {
            ev.stopImmediatePropagation();
            break;
          }
        }
        if (ev.target.tagName === "A") {
          if (ev.target.href.substr(-1) !== "#")
            // A true link
            break;
        }
        break;
      case KEYS.SPACE:
        if ($target.is('[role="button"]')) {
          $target.trigger("click");
          return false;
        }
        break;
      case KEYS.BACKSPACE:
        return dispatchBackspace(ev);
      // Escape from modal window
      case KEYS.ESC:
        $(".closable").hide();
        break;
      case KEYS.KP_RADIX:
        if ($target.data("type") === "numedit") {
          $target.insertAtCaret(_("__radixpoint__", "."));
          return false;
        }
    }
    return undefined;
  }
};

function gridKeys(ev) {
  var target = ev.originalEvent.target,
    $target = $(target);
  switch (ev.keyCode) {
    case KEYS.UP:
      $(ev.target).prev().trigger("focus");
      return false;
    case KEYS.DOWN:
    case KEYS.TAB:
      if ($target.find(":input, a").length !== 1) {
        return true;
      }
      if (
        $target.find(
          "a, :input" + ':not([type="checkbox"])' + ':not([type="radio"])'
        ).length
      ) {
        return true;
      }
      if (ev.shiftKey) $target.prev().trigger("focus");
      else $target.next().trigger("focus");
      return false;
    case KEYS.SPACE:
      var $inputs = $target.find(
          'input[type="checkbox"], ' + 'input[type="radio"]'
        ),
        $input = $inputs.filter(":nth(0)");
      if ($inputs.length > 2) return true;
      else $input.prop("checked", !$input.is(":checked"));
      return false;
  }
  return true;
}

function aintTheEnterKey(ev) {
  return ev.type === "keydown" && ev.keyCode !== KEYS.ENTER;
}

function dispatchBackspace(ev) {
  if (!ev.shiftKey) return true;
  if (Mode.get("hasNoPrior")) return false;
  step("prior");
  ev.preventDefault();
  ev.stopImmediatePropagation();
  return false;
}

$(document).on("keydown", maps.questions);

$(document).on("keydown", ".bb-btn", function (ev) {
  if (ev.keyCode === 13) {
    // Dispatch to click handler on ENTER.
    $(this).trigger("click");
    return false;
  }
  return true;
});
/*** KEYMAP END ***/

/*** ROLES BEGIN ***/

function setRole() {
  var userinfo = Vars.getVar("userinfo") || {};

  Mode.toggle("isAdmin", userinfo.role === "administrator");
  Mode.toggle("isUser", userinfo.role === "user");
  Mode.toggle("isViewer", userinfo.role === "viewer");
  Mode.toggle("isVieweradmin", userinfo.role === "vieweradmin");
  Mode.toggle("isGuest", userinfo.role === "guest");
  Mode.toggle("isAnonymous", userinfo.fullname === "anonymous");
  const perms = permissions();
  perms.forEach(p => {
    Mode.toggle(p, true, false);
  });
  Mode.toggle("webadminMakesSense", webadminMakesSense(perms), false);
}

/*** ROLES END ***/

/*** INITIALIZATION BEGIN ***/

$(function () {
  $("body").attr("data-modus", "none");

  document.addEventListener("submit", function (ev) {
    var action = ev.target.getAttribute("action");
    if (!action) {
      ev.preventDefault();
      return false;
    }
    return undefined;
  });

  $(document).on("submit", "form#bb-login", function () {
    // Serialize form as array
    var params = $(this).serializeArray(),
      action = this.getAttribute("action");
    // Trim values and set the desired format
    $.each(params, function (_, val) {
      if (val.name === "fmt") val.value = "json";
      else val.value = (val.value || "").trim();
    });
    $.postJSON(
      action,
      [$.param(params), window.location.search.substring(1)].join("&")
    );
    return false;
  });

  var formfocus = window.setTimeout(function () {
    $("form#bb-login input[name=username]").trigger("focus");
  }, 0);

  bb.Router = function router(params) {
    if (
      (typeof params.username !== "undefined" &&
        typeof params.password !== "undefined") ||
      params.uniqueid ||
      params.modelid ||
      params.modelname ||
      params.dbname ||
      params.state ||
      params.request ||
      params.bsid
    ) {
      Mode.set("isDeepLinked");
      hideLogin();
      if (params.bsid) new BBI().authenticate();
      else if (!bb.autologinrewritten) {
        var action;
        if (
          typeof params.username !== "undefined" &&
          typeof params.password !== "undefined"
        )
          action = "login";
        if (params.uniqueid) action = "menu";
        // Studio deeplink
        if (typeof params.uniqueid === "undefined" && params.modelid)
          action = "open";
        if (params.uniqueid && (params.modelid || params.dbname))
          action = "action";
        if (params.modelname) action = "open";
        if (params.request) {
          action = params.request;
          delete params.request;
        }
        $.postJSON(action, $.param(params) + "&fmt=json").then(setSettled);
      }
      window.clearTimeout(formfocus);
    }
  };

  if (window.location.search.length > 1) {
    bb.Router($.parseQuery());
  } else setSettled();

  $(document).on("bb:renderQuestions", renderGroups);
});

/**
 * Set the effect to be used when re-showing login form.
 *
 * @param {String} effect One of 'show', 'fadeIn' or 'slideDown'
 */
function safeResetEffect(effect = "slideDown") {
  if (typeof effect !== "string") {
    console.warn("Argument effect should be a string");
    return "slideDown";
  }
  if (!/^(show|fadeIn|slideDown)$/.test(effect)) {
    console.warn("Invalid effect: " + effect);
    return "slideDown";
  }
  return effect;
}

resetLogin.effect = safeResetEffect(
  arbitraryCoreProp("loginResetEffect", "slideDown")
);

function resetLogin() {
  $("#bb-login")[resetLogin.effect]();
}

/*** INITIALIZATION END ***/
/*** JUMPLIST BEGIN ***/
$(document).on("change", ".bb-jumplist-dropdown select", function () {
  bb.gotonode($(this).val());
});

$(document).on("click", "[data-groupid]", function () {
  var $this = $(this),
    groupid = $this.attr("data-groupid");
  bb.gotonode(groupid);
});

/*** JUMPLIST END ***/

/*** CASES BEGIN ***/
$.fn.deleteme = function () {
  if (
    confirm(
      _("Delete") + " " + (this.length == 1 ? _("case") : _("cases")) + "?"
    )
  ) {
    return this.each(function () {
      var me = $(this);
      if (me.hasClass("bb-case")) {
        var casus = {
          dbname: me.data("dbname"),
          sessionid: me.data("sessionid")
        };
        deleteCase(casus.dbname, casus.sessionid, Vars.getVar("uniqueid"));
        if (isCaseCurrent(casus)) {
          $("#bb-q").empty();
          Mode.unset("hasModel");
        }
      }
    });
  }
  return this;
};

var Cases = (function () {
  var _cases = [];
  var _unfilteredcases = [];
  var _MAX = 10;
  var _idx = 0;
  var _filtertext = _("filter cases by name");

  function update(cases) {
    _unfilteredcases = cases || [];
    _cases = cases || [];
    if (cases && cases.length > 0) {
      cases.sort(function (a, b) {
        return a.dateenter > b.dateenter ? -1 : 1;
      });
      var $controls = $("#bb-cases-controls");
      if ($controls.is(":empty")) {
        $controls.html(
          ' <button aria-label="' +
            positionalFormat(_("first {0} results"), _MAX) +
            '" id="bb-cases-first">&lt;&lt;</button> ' +
            ' <button aria-label="' +
            positionalFormat(_("previous {0} results"), _MAX) +
            '" id="bb-cases-prev">&lt;</button> ' +
            ' <span tabindex="0" id="bb-cases-currentslice">1-10</span>' +
            ' <button aria-label="' +
            positionalFormat(_("next {0} results"), _MAX) +
            '" id="bb-cases-next">&gt;</button> ' +
            ' <button aria-label="' +
            positionalFormat(_("last {0} results"), _MAX) +
            '" id="bb-cases-last">&gt;&gt;</button> ' +
            '<input id="bb-cases-filter" ' +
            'placeholder="' +
            _filtertext +
            '" ' +
            'aria-label="' +
            _filtertext +
            '" ' +
            'type="text" value="" size="10" />'
        );
        $controls.attr("data-unbound", true);
      }
      if ($controls.attr("data-unbound")) {
        $controls.removeAttr("data-unbound");
        $("#bb-cases-prev").click(prevSlice);
        $("#bb-cases-next").click(nextSlice);
        $("#bb-cases-first").click(showSlice.bind(null, 0));
        $("#bb-cases-last").click(
          showSlice.bind(null, Math.floor((_cases.length - 1) / _MAX))
        );

        $("#bb-cases-filter", $controls).keyup(function (ev) {
          if (ev.keyCode === KEYS.TAB) return true;
          var $this = $(this),
            val = ($this.val() || "").trim();
          if (val != "") {
            var re = new RegExp(val, "i");
            _cases = _unfilteredcases.filter(function (e) {
              return re.test(e.name);
            });
          } else _cases = _unfilteredcases;
          showSlice(0);
          return false;
        });
      }
      showSlice(0);
    } else {
      empty();
    }
  }
  function showSlice(idx) {
    _idx = idx;
    var caselen = _cases.length;

    $("#bb-cases .bb-case").remove();

    $(_cases.slice(_idx * _MAX, (_idx + 1) * _MAX)).each(function (i) {
      wCasus(_cases[i + _idx * _MAX]).appendTo("#bb-cases-table");
    });
    if (_cases.length) {
      $(
        '<thead><tr class="bb-case">' +
          '<td class="bb-case-name" colspan="' +
          howManyColumns() +
          '"><button class="bb-newcase" data-bb:dbname="' +
          _cases[0].dbname +
          '">' +
          _("create a new case") +
          "</button>" +
          "</td>" +
          "</tr>" +
          (bb.Plugins.newname
            ? '<tr class="bb-newname-row">' +
              '<td class="bb-newname-cell" colspan="' +
              howManyColumns() +
              '">' +
              '<input class="bb-newname" type="text" placeholder="' +
              _("case name") +
              '"/>' +
              "</td>" +
              "</tr>"
            : "") +
          "</thead>"
      ).prependTo("#bb-cases-table");

      // Some browsers do leave thead and tbody in place, even when
      // $().empty-ing the table, so:
      $("#bb-cases-table thead~thead").remove();
    }

    $("#bb-cases-currentslice")
      .text(
        _idx * _MAX +
          1 +
          "-" +
          Math.min(caselen, (_idx + 1) * _MAX) +
          "/" +
          caselen
      )
      .attr(
        "aria-label",
        positionalFormat(
          _("results {0} to {1} from {2}"),
          _idx * _MAX + 1,
          Math.min(caselen, (_idx + 1) * _MAX),
          caselen
        )
      );

    $("#bb-cases-prev, #bb-cases-first").prop("disabled", _idx == 0);
    var hasNoNext = _idx == Math.floor((caselen - 1) / _MAX);
    $("#bb-cases-next, #bb-cases-last").prop("disabled", hasNoNext);

    $("#bb-cases").trigger("bb:rendered");
  }
  function nextSlice() {
    var divident = Math.floor(_cases.length / _MAX);
    showSlice(Math.min(_idx + 1, divident));
  }
  function prevSlice() {
    showSlice(Math.max(_idx - 1, 0));
  }
  function empty() {
    $("#bb-cases-table").empty();
  }
  return {
    empty: empty,
    update: update
  };
})();

function howManyColumns() {
  var base = 2;
  return (
    $.grep(["showreport", "showdeleteinmenu", "showcopycase"], Vars.getVar)
      .length + base
  );
}

function wCasus(casus) {
  var cas = $.extend(
    {},
    casus,
    // Turn into JavaScript dates, and normalize as good as we can:
    {
      dateenter: casus.dateenter && parseDate(casus.dateenter),
      datecreate:
        Vars.getVar("showdatecreated") &&
        casus.datecreate &&
        parseDate(casus.datecreate)
    },
    {
      showcopycase: Vars.getVar("showcopycase"),
      showdeleteinmenu: Vars.getVar("showdeleteinmenu")
    }
  );
  if (Vars.getVar("showreport")) cas.reporturl = urlutils.caseReport(casus);
  // Turn into JavaScript dates, and normalize as good as we can:
  if (cas.datecreate) cas.firstrun = humanDate(cas.datecreate);
  if (cas.dateenter) cas.lastaccess = humanDate(cas.dateenter);
  var html = bb.createCaseItem(cas);

  var $case = $(html);

  $case.find(".bb-case-name").bind("click keydown", function (ev) {
    if (aintTheEnterKey(ev)) return;
    Ajax.replace({
      url: "action",
      data: {
        dbname: casus.dbname,
        sessionid: casus.sessionid,
        uniqueid: Vars.getVar("uniqueid"),
        fmt: "json"
      }
    });
  });
  $case.find(".bb-case-copy").bind("click keydown", function (ev) {
    if (aintTheEnterKey(ev)) return;
    Ajax.replace({
      url: "action",
      data: {
        dbname: casus.dbname,
        templateindex: casus.sessionid,
        uniqueid: Vars.getVar("uniqueid"),
        fmt: "json"
      }
    });
  });
  $case.data("sessionid", casus.sessionid);
  $case.data("dbname", casus.dbname);
  return $case;
}

bb.createCaseItem =
  bb.createCaseItem ||
  function (casus) {
    var dateTitle,
      dateSpan = "",
      copySpan = "",
      reportSpan = "",
      deleteSpan = "",
      classes = ["bb-case"];
    dateTitle = _("Last opened") + ": " + casus.lastaccess;
    if (Vars.getVar("showdatecreated")) {
      dateTitle += ", " + _("created") + ": " + casus.firstrun;
    }
    dateSpan =
      '<td class="date" title="' +
      dateTitle +
      '">' +
      casus.lastaccess +
      "</td>";
    if (Vars.getVar("showreport")) {
      reportSpan =
        '<td class="report">' +
        '<a target="_blank" href="' +
        casus.reporturl.replace(/&/g, "&amp;") +
        '">' +
        '<span class="icon" aria-hidden="true">&#9776;</span> ' +
        _("report") +
        "</a></td>";
    }
    if (Vars.getVar("showdeleteinmenu")) {
      deleteSpan =
        "<td>" +
        '<button class="bb-case-delete">' +
        '<span class="icon" aria-hidden="true">&#10008;</span>' +
        " " +
        _("Delete") +
        "</button>" +
        "</td>";
    }

    if (Vars.getVar("showcopycase")) {
      copySpan =
        "<td>" +
        '<button class="bb-case-copy">' +
        '<span class="icon"></span>' +
        " " +
        _("copy") +
        "</button>" +
        "</td>";
    }

    if (isCaseCurrent(casus)) {
      classes.push("current");
    }

    return (
      '<tr class="' +
      classes.join(" ") +
      '">' +
      "<td>" +
      '<button class="bb-case-name" tabindex="0" aria-label="' +
      dateTitle +
      ", " +
      _("case name") +
      ": " +
      casus.name +
      '">' +
      (casus.name || _("open")) +
      "</button></td>" +
      dateSpan +
      reportSpan +
      deleteSpan +
      copySpan +
      "</tr>"
    );
  };

function isCaseCurrent(casus) {
  return (
    casus.sessionid == Vars.getVar("sessionid") &&
    casus.dbname == Vars.getVar("dbname")
  );
}

function deleteCase(dbname, sessionid, uniqueid) {
  // Ajax.last && Ajax.last.abort();
  // todo: voeg nieuwe waarden toe aan object.
  Ajax.post({
    url: "delete",
    data: {
      dbname,
      sessionid,
      uniqueid,
      fmt: "json"
    }
  });
}

$(document).on("click keydown", ".bb-case-delete", function (ev) {
  if (ev.type === "keydown" && ev.keyCode !== KEYS.ENTER) return;
  $(this).parents(".bb-case").deleteme();
});

function newcase(dbname, newname, params = {}) {
  const data = Object.assign(
    {},
    Object(params) === params && params,
    {
      dbname: dbname,
      uniqueid: Vars.getVar("uniqueid"),
      step: "open",
      fmt: "json"
    },
    newname && { newname }
  );
  if (Vars.getVar("sessionid"))
    step("exit", function (jsondata) {
      Ajax.busy = false;
      if (jsondata.status === "Ready") {
        Ajax.replace({ data: data });
      }
    });
  else {
    Ajax.replace({ data: data });
  }
}

$(document).on("click keydown", ".bb-newname", function (ev) {
  if (ev.type === "click" || aintTheEnterKey(ev)) ev.stopPropagation();
  return true;
});

$(document).on("click keydown", ".bb-newcase", function (ev) {
  if (aintTheEnterKey(ev)) return true;
  const $this = $(this),
    dbname =
      this.getAttribute("data-bb:dbname") ||
      $this.parents(".bb-model").attr("data-bb:dbname"),
    newname = $this.find(".bb-newname").val(),
    params = collectAttributes("data-bb:params-", this);
  newcase(dbname, newname, params);
  return false;
});

/*** CASES END ***/

/*** MODELS BEGIN ***/
var Models = {
  selector: "#bb-models",
  modelitem: function (model) {
    model.uniqueid = Vars.getVar("uniqueid");
    return (
      (bb.createModelItem && bb.createModelItem(model)) ||
      (function (model) {
        var dbname = model.dbname;
        return (
          '<tr class="bb-model ' +
          model._selectedclass +
          " bb-yours-" +
          model.yours +
          '" id="model' +
          dbname +
          '" data-bb:dbname="' +
          dbname +
          '">' +
          "<td>" +
          '<button class="bb-model-name bb-model-cases">' +
          bb.escapeHTML(model._nicename) +
          "</button>" +
          "</td>" +
          '<td><button class="bb-newcase" data-bb:dbname="' +
          dbname +
          '">' +
          _("new") +
          "</button></td>" +
          "</tr>"
        );
      })(model)
    );
  },
  // Enhance Model with extra computed properties:
  enhanceModel: function (model) {
    model._selectedclass = model.selected ? "selected" : "";
    model._nicename = model.modelname.replace(/_/g, " ");
    if (model.lastupdate) {
      model._date = parseDate(model.lastupdate);
      model._humandate = humanDate(model._date);
    }
    if (model.modelinfo) {
      model._liner_notes = model.modelinfo.split(/(?:\r?\n|\\r\\n|\\n)/);
    }
    if (model.authorinfo) {
      model._author_notes = model.authorinfo.split(/(?:\r?\n|\\r\\n|\\n)/);
    }
    return model;
  },
  update: function (data) {
    var models = data.models;
    models.sort(compareVersionsOn.bind(null, "modelname"));

    var explicit = models.filter(function (m) {
      return typeof m["order"] === "number";
    });
    if (explicit[0]) {
      explicit.sort(function (a, b) {
        return (
          a["order"] - b["order"] ||
          compareVersions(String(a["order"]), String(b["order"]))
        );
      });
      models = models.filter(function (m) {
        // absent (undefined) or the empty string
        return typeof m["order"] !== "number";
      });
      models = explicit.concat(models);
    }

    this.empty();
    var self = this;
    $(this.selector).append(
      $.map(models, function (model) {
        return self.modelitem(self.enhanceModel(model));
      })
    );
  },
  empty: function () {
    $(this.selector).empty();
  }
};

$(document).on("click keydown", ".bb-model-cases", function (ev) {
  if (aintTheEnterKey(ev)) return;
  var $this = $(this),
    dbname =
      this.getAttribute("data-bb:dbname") ||
      $this.parents(".bb-model").attr("data-bb:dbname");
  Ajax.replace({
    url: "menu",
    data: {
      dbname: dbname,
      uniqueid: Vars.getVar("uniqueid"),
      fmt: "json"
    },
    dataType: "json"
  });
});
/*** MODELS END ***/

/*** NAVIGATION, REQUESTS BEGIN ***/

/**
 * Request 'action'
 *
 * @param {String}   direction One of 'prior', 'next', 'exit', 'runtonode', 'gotonode', 'update' or 'updatemis'
 * @param {Function} cb        Callback function to run on succes, defaults to checkJSON()
 * @param {Object}   options   Object, with possible keys: 'fullnodename' : 'graph.node',
 *                                                         'groupid'      : 'groupid-iteration',
 *                                                         'sync'         : Boolean
 */
function step(direction, cb, options = {}) {
  Validation.reset();
  if (Ajax.busy) return;

  Ajax.last && Ajax.last.abort();
  Ajax.direction = direction;
  Ajax.row = Ajax.direction === "update" && options && options.update;

  try {
    if (
      ["next", "skip"].includes(direction) &&
      $("#bb-q .group:not([disabled]) .validatable:visible")
        .validate({ silent: false, justhide: false, requestUpdate: false })
        .filter("[aria-invalid=true]").length > 0
    )
      throw new Error("There are errors, please double check your answers.");

    const container = either(prop("groupElt"), () =>
      document.querySelector(".group.selected")
    )(options);
    const screenid = Vars.getVar("screenid");
    const groupid = $.data(container).groupid;
    Ajax.groupid = groupid;

    // todo: voeg nieuwe waarden toe aan object.
    if (!(direction === "prior" && Mode.get("hasNoPrior"))) {
      const ajaxOptions = {
        async: true && (!options || !options.sync), //See noted render() as a reason for this.
        data: [
          "step=" + direction,
          direction === "update" && options && options.update
            ? "update=" + encodeURIComponent(options.update)
            : "",
          direction === "runtonode"
            ? "fullnodename=" + options.fullnodename
            : "",
          direction === "gotonode" ? "groupid=" + options.groupid : "",
          Vars.querify(Vars.SESSION_KEYS),
          "screenid=" + groupid,
          "fmt=json",
          collectWithin({
            container,
            params: new URLSearchParams(options.extraparams)
          })
            .toString()
            .replace(/\r?\n/g, "%0D%0A")
        ]
          .filter(Boolean)
          .join("&"),
        success: function (data, status, req) {
          data._direction = direction;
          data._passed = options && options.pass;
          data._isUpdate = propEq("isUpdate", true, options);
          // if (direction === "update" && groupid !== screenid && editPolicy(conf) === "stay") {
          //   container.classList.remove("unselected");
          //   container.classList.add("selected");

          //   // Do not render, just update
          //   Ajax.release();
          //   Vars.setVars(data);
          //   updateDynProps(data);
          // } else

          if (groupid !== screenid && editPolicy(conf) === "return") {
            // Do not render, we're going back again. This would be
            // nice, but we do need some values to be rerendered -
            // warranting redraw of nodes after the edited one.

            Ajax.release();
            Vars.setVars(data);
          } else if (options && options.cbIsAdditional) {
            options.cbIsAdditional === "before" && cb && cb(data, status, req);
            checkJSON(data, status, req);
            options.cbIsAdditional !== "before" && cb && cb(data, status, req);
          } else {
            (cb || checkJSON)(data, status, req);
          }
          if (
            Ajax.row &&
            groupid === screenid &&
            compose(
              when(Boolean, any(propEq("dynamic", true))),
              prop("groups")
            )(data)
          ) {
            console.info(
              "Requesting an extra update for dynprops. Should be handled by server instead"
            );
            window.setTimeout(bb.update, 0);
          }
        }
      };

      if (
        screenid !== undefined &&
        direction !== "update" &&
        groupid !== screenid
      ) {
        console.warn(
          `groupid ${groupid} is not the current screenid ${screenid}, but no update was requested`
        );
      }
      if (direction === "update" && groupid !== screenid) {
        // Hold your breath, first go back, so as to put server pointer at the right node.
        bb.gotonode(
          // Will get the .selected
          groupid,
          data => {
            Ajax.release();
            Vars.setVars(data); // Sets screenid
            Ajax.direction = direction;
            // Is always "update", actually;
            Ajax.row = direction === "update" && options && options.update;
            Ajax.groupid = groupid;
            const req = Ajax.post(ajaxOptions); // Gets the original callback, if any.
            if (editPolicy(conf) === "return")
              req.then(data => {
                Ajax.release();
                Vars.setVars(data);

                bb.gotonode(
                  screenid,
                  () => {
                    // The gotonode invocation just overwrote the direction and row.
                    Ajax.direction = direction;
                    Ajax.row =
                      direction === "update" && options && options.update;
                    if (!Ajax.row) cb && cb();
                  },
                  {
                    cbIsAdditional: "before",
                    groupElt: container,
                    isUpdate: true
                  }
                );
              });
          },
          { sync: false, cbIsAdditional: false }
        );
      } else {
        Ajax.post(ajaxOptions);
      }
    }
  } catch (e) {
    $(document).trigger("bb:userError", e.message);
    A11y.log(_(e.message));
  }
}

let lastUpdateRequest;

function requestDynProps(input) {
  if (Ajax.busy) return;

  var thisUpdateRequest;

  Ajax.last && Ajax.last.abort();
  Ajax.direction = "update";
  // Ajax.row = Ajax.direction === 'update' && options && options.update;

  const ajaxOptions = {
    async: true,
    data: [
      "step=update",
      Vars.querify(Vars.NAV_KEYS),
      "fmt=json",
      serializeQuestions()
    ]
      .filter(Boolean)
      .join("&"),
    success: (...args) => {
      if (thisUpdateRequest === lastUpdateRequest) {
        $(document).trigger("bb:preHandleData", ...args);
        updateDynProps(args[0], input);
      }
    }
  };
  lastUpdateRequest = thisUpdateRequest = Ajax.post(ajaxOptions);
}

// bb:prePost handler always goes off on bb.ajax.post.
$(document).on("bb:prePost", function (event, options) {
  if (includes(options.url, ["action", "open", "bbisreturns"]))
    if (!includes(Ajax.direction, ["update", "updatemis"]))
      $(document).trigger("bb:preStep", options);
});

// bb:preStep handler goes off after user-initiated, possibly
// expensive, actions.
$(document).on("bb:preStep", function () {
  Ajax.busy = true;
  // Hide lingering calendars
  $(".group.selected .hasDatepicker").datepicker("hide");
  A11y.log("");
});

// Save
$(document).on("click", ".bb-save", function () {
  step("save", null);
});

// Update
$(document).on("click", "[name=update]", function (ev) {
  step("update", null, {
    update: $(this).val(),
    groupElt: ev.target.closest(".group")
  });
});

// Prior
$(document).on("click", ".bb-prior", function () {
  step("prior");
});

// Next
$(document).on("click", ".bb-next", function (ev) {
  bb.next();
  ev.preventDefault();
  ev.stopImmediatePropagation();
  return false;
});

// Skip
$(document).on("click", ".bb-skip", function (ev) {
  bb.skip();
  ev.preventDefault();
  ev.stopImmediatePropagation();
  return false;
});

$(document).on("keydown", ".group a", function (ev) {
  if (
    ev.shiftKey &&
    ev.keyCode === KEYS.ENTER &&
    ev.target.href.substr(-1) !== "#"
  ) {
    // true link BUT SHIFT + ENTER
    bb.next();
    ev.preventDefault();
    ev.stopImmediatePropagation();
    return false;
  }
  return true;
});

// Close
$(document).on("click", ".bb-close", function () {
  logout();
  self.close();
  $("body").html(_("You may now safely close this window"));
});

// Restart
$(document).on("click", ".bb-restart", function (event) {
  if (
    "noconfirm" in event.currentTarget.dataset ||
    confirm(_("Are you sure? This will reset all values."))
  )
    bb.restart();
  return false;
});

/**
 * Log out
 *
 * @param {Boolean} ev  Either a jQuery event or not
 * @param {Function} cb Callback function to be run after logout.
 * Supercedes default action on Ajax request. @see Ajax.post.
 */

const timedOutResponse = () => ({
  error: {
    code: 9 //Errors.CODES.cWebSessionTimeOut
  }
});

function logout(ev, cb) {
  if (Vars.getVar("uniqueid")) {
    exit(function () {
      const options = {
        url: "logout",
        data: "fmt=json&" + Vars.querify("uniqueid"),
        async: false
      };
      // When called directly, which
      if (cb instanceof Function) {
        options.success = options.error = cb;
      }
      Ajax.post(options);
    });
  } else {
    console && console.info && console.info("Fake logging out, ID is missing");
    const mockResponse = timedOutResponse();
    ((cb instanceof Function && cb) || checkJSON)(mockResponse, 200, {
      responseJSON: mockResponse,
      responseText: JSON.stringify(mockResponse)
    });
  }
  return false;
}

$(document).on("click", ".bb-logout", logout);
$(document).on("keydown", ".bb-logout", function (ev) {
  if (ev.keyCode !== KEYS.ENTER && ev.keyCode !== KEYS.SPACE) return true;
  logout(ev);
  return false;
});

/** Exit
 *
 * Exit the current case;
 * @param {Function} fun Function to execute after having exited.
 * If exiting isn't necessary, still execute fun.
 */
function exit(fun, sync = true) {
  if (typeof fun !== "function")
    // Could be an event object on .bb-stop
    fun = undefined;
  if (shouldExit()) {
    step("exit", fun, { sync });
  } else fun && fun();
}

$(document).on("click", ".bb-stop", exit);

// Request 'getuserinfo'
function getUserInfo() {
  $.postJSON("getuserinfo", Vars.querify("uniqueid") + "&fmt=json");
}

/*** NAVIGATION, REQUESTS END ***/

/*** MENU BEGIN ***/

function setupMenu() {
  $(".bb-settings").attr({ target: "blank" });
}

// Open WebAdmin (in new page)
function openSettings() {
  var href = fromApiServer("webadmin" + "?" + Vars.querify("uniqueid"));
  window.open(href);
  return false;
}

$(document).on("click", ".bb-settings", openSettings);
$(document).on("keydown", ".bb-settings", function (ev) {
  if (ev.keyCode !== KEYS.ENTER && ev.keyCode !== KEYS.SPACE) return true;
  openSettings(ev);
  return false;
});

/** menu
 *
 * Open menu (model overview)
 * @param {String|Object|undefined} creds Optional credentials,
 *                                        defaults to fmt:json and uniqueid
 */
function menu(creds) {
  return $.postJSON(
    "menu",
    creds || {
      fmt: "json",
      uniqueid: Vars.getVar("uniqueid")
    }
  );
}

/** exitthenmenu
 *
 * Exit a case, then open a menu
 * @param {Event} ev Optional event whose propagation will be stopped
 */
function exitthenmenu(ev) {
  exit(function () {
    menu();
  });
  ev && ev.stopPropagation && ev.stopPropagation();
}

$(document).on("click", ".bb-openmodels", exitthenmenu);
$(document).on("keydown", ".bb-openmodels", function (ev) {
  if (ev.keyCode !== KEYS.ENTER) return;
  exitthenmenu(ev);
});

/*** MENU END ***/

/*** MISC UI BEGIN ***/

function hideLogin() {
  $("form#bb-login").hide();
}

/**
 * Simple class toggling to implement collapsing/expanding widgets.
 *
 * Needs CSS styling and / or Event handler registered on custom
 * jQuery 'bb:collapsing' Event.
 */
$(document).on("click keydown", ".bb-collapsable .bb-collapser", function (ev) {
  if (aintTheEnterKey(ev) || ev.shiftKey) return true;
  $(this)
    .closest(".bb-collapsable")
    .toggleClass("bb-collapsed")
    .trigger("bb:collapsing");
  return false;
});

/*** MISC UI END ***/

/*** DATA HANDLERS BEGIN ***/

/**
 * Default handlers for JSON object.
 *
 * Order in which these handlers are executed are:
 *
 * bb:preHandleData
 * bb:handleData
 * bb:postHandleData
 * bb:finalHandleData
 */

$(document).on("bb:preHandleData", function (event, data) {
  if (data && data.groups) {
    data.groups.forEach(function (group) {
      const groupid = group.groupid;
      group.controls.forEach(function (control) {
        control._originalid = control.id;
        control.id = groupid + "-" + control.id;
        if (control.isfor) {
          control._originalisfor = control.isfor;
          control.isfor = groupid + "-" + control.isfor;
        }
        if (control.controltype === "label") {
          control.value = control.value.trim();
          if (control.isfor && control.value)
            control.value = control.value + " ";
        }
        if (
          control.controltype === "memo" &&
          control.maxlength > 0 &&
          !control.placeholder
        ) {
          control.placeholder = positionalFormat(
            _("Maximum allowed characters: {0}"),
            control.maxlength
          );
        }
      });
    });
  }
});
/**
 * Default handler for JSON object.
 *
 * Sets mode, variables, calls functions to update UI.
 *
 */
function onHandleData(event, data) {
  // Save previous modus - it will be the next modus if unset.
  var modus = $("body").attr("data-modus"); // Either 'model', 'menu', or 'none'

  Mode.unset("hasMessage");
  if (typeof data == "undefined") return;
  if (typeof document.selection != "undefined")
    try {
      document.selection.removeAllRanges();
    } catch (e) {
      // tryCatch was there for IE's sake. probably because we were
      // using Selection.empty()
    }

  // Fix error objects - they are a mess
  if (data.error) {
    data.error = Errors.translate(data.error);
    // Do not throw the error just yet - we may need it to
    // get in the right mode
  }

  Vars.setVars(data);

  if (data.userinfo) {
    Mode.set("isLoggedIn");
    setRole();
    setupMenu();
    return;
  }

  if (
    data.error &&
    ([
      Errors.CODES.cWebPleaseLogin,
      Errors.CODES.cUMWrongUserNamePassword,
      Errors.CODES.cWebSessionTimeOut
    ].indexOf(data.error.code) > -1 ||
      data.error.code === "UNAUTHORIZED")
  ) {
    // Do nothing
  } else if (has("bbis", data)) {
    // Authenticate through BBI
    new BBI(data).authenticate();
    return;
  } else if (Vars.getVar("uniqueid")) {
    // We are apparently logged in
    hideLogin();
    if (!Vars.getVar("userinfo")) {
      // Get user information
      getUserInfo();
    }
  }

  // "DrawScreen: end"
  /* Only set modus if this is possibly mode-changing data (e.g.
   * DON'T even go here when data.userinfo is true).
   */
  if (data.status || data.groups || data.cases || data.models || data.error) {
    if (data.groups) modus = "model";
    else if (
      data.models ||
      data.cases ||
      (data.status && data.status == "Ready")
    ) {
      modus = "menu";
    } else if (data.status && data.status == "logout successful") {
      modus = "none";
    } else if (data.error && data.error.code === Errors.CODES.cWebPleaseLogin) {
      modus = "none";
    } else if (
      data.error &&
      data.error.code === Errors.CODES.cUMWrongUserNamePassword
    ) {
      modus = "none";
    } else if (
      data.error &&
      data.error.code === Errors.CODES.cWebSessionTimeOut
    ) {
      modus = "none";
    } else if (data.error && data.error.code === "READY") {
      modus = "menu";
    }
    $("body").attr("data-modus", modus);
    // Set current modus

    // Clean up state vars that were left over
    if (modus === "menu") {
      Vars.unsetVars(["sessionid", "screenid"]); // Session specific data
    }
    if (modus === "none") {
      const perms = permissions();
      Vars.unsetVars();
      perms.forEach(p => {
        Mode.toggle(p, false, false);
      });
    }

    // Will need to be seen with every control
    Mode.unset("hasHints");

    if (!data.error)
      Mode.toggle("hasNoModelsShown", modus !== "menu")

        .toggle("hasModel", modus === "model")

        .toggle("hasMenu", modus === "menu")

        .toggle(
          "hasModels",
          modus === "menu" && !!data.models && !!data.models.length
        )

        .toggle(
          "hasCases",
          modus === "menu" && !!data.cases && !!data.cases.length
        )

        .toggle(
          "hasJumplist",
          modus === "model" && !!data.jumplist && !!data.jumplist.length
        )

        .toggle(
          "hasInformationsources",
          modus === "model" &&
            data.informationsources &&
            !!data.informationsources.length
        )

        .toggle("hasNoPrior", modus === "model" && !data.hasprevious)

        .toggle("hasNoNext", modus === "model" && !data.hasnext);

    Mode.toggle("isLoggedIn", modus !== "none");

    if (modus === "none") {
      Mode.unset("isDeepLinked");
      setRole(); // Sets Mode
    }
    if (modus !== "model") {
      Mode.unset("isValidated");
    }
  }

  if (
    data.error &&
    !includes(data.error.code, propOr([], "ignoredErrorCodes", conf))
  ) {
    notify(
      {
        keepalive: path(["arbitrary", "core", "notify", "keepalive"], conf),
        html: false
      },
      data.error
    );
  }

  // View updates
  if (data.modeldescription) {
    $(".bb-modelname")
      .text(data.modeldescription.replace(/_/g, " "))
      .attr("lang", data.modellanguage);
  } else if (modus !== "model") {
    $(".bb-modelname").text("");
  }

  if (modus !== "model") {
    $("#bb-q").empty();
  }

  if (modus !== "menu") {
    Cases.empty();
    Models.empty();
  }

  if (modus === "none") {
    resetLogin();
  }

  if (modus === "none") {
    Mode.unset("hasModel")
      .unset("hasNoModelsShown")
      .unset("hasMenu")
      .unset("hasModels")
      .unset("hasCases")
      .unset("hasJumplist")
      .unset("hasInformationsources")
      .unset("hasNoPrior")
      .unset("hasNoNext");
  }

  if (modus === "menu") {
    if (data.models && !!data.models.length) {
      Models.update(data);
    }
    if (data.cases && !!data.cases.length) {
      Cases.update(data.cases);
    }
  }

  if (modus === "model") {
    if (data.groups) {
      Validation.reset();
      $(document).trigger("bb:renderQuestions", data);
    }
    Validation.setMode(); // Sets Mode

    $(".bb-openattachments").attr("href", urlutils.getFiles());

    // if (data.informationsources){
    //   runHook("informationsources")(data.informationsources);
    // }
    if (data.jumplist) {
      Jumplist.type = arbitraryCoreProp("jumplist.type") || "ul";
      Jumplist.draw(data.jumplist);
    }
  }
}

$(document).on("bb:handleData", onHandleData);

/**
 * Default final handler for JSON object.
 *
 * Runs <tt>after</tt> any DOM updates. Should only be used for focusing or non-UI stuff.
 *
 * Do not override (unless you know exactly what you are doing) --
 * just augment it if need be.
 *
 */
$(document).on("bb:finalHandleData", function () {
  bb.ajax.release();
});

let returnfocusto, returnSelection;

const $document = $(document);

$document.on("focus", ":input", ev => {
  const activeElement = ev.target;
  returnfocusto = activeElement.getAttribute("id");
  if (activeElement.value)
    returnSelection = {
      selectionStart: 0,
      selectionEnd: activeElement.value.length,
      selectionDirection: "forward"
    };
});

$document.on("keydown", ":input", ev => {
  const activeElement = ev.target;
  const { selectionStart, selectionEnd, selectionDirection } = activeElement;
  returnSelection = { selectionStart, selectionEnd, selectionDirection };
});

function returnfocus() {
  try {
    let elt = document.querySelector(`[id="${returnfocusto}"]`);
    if (elt) {
      elt.focus();
      if (elt.classList.contains("hasDatepicker")) {
        $(elt).datepicker("widget").hide();
      }
      let { selectionStart, selectionEnd, selectionDirection } =
        returnSelection;
      elt.setSelectionRange(selectionStart, selectionEnd, selectionDirection);
    }
  } catch (e) {
    // Checkbox throw an error that some object is not or no
    // longer usable. But how may we check?

    // Number inputs and such
    e.select && e.select();
    return true;
  }
  return false;
}

function focusHandler(event, data) {
  if (data.groups) {
    window.setTimeout(function () {
      const [grid, row] = (Ajax.row || "").split(".");
      var $input,
        focusstring = ":input:visible:enabled:not([readonly]):last";
      if (row) {
        if (row === "+") {
          // Addbutton for entire grid
          $input = $(`.group [name="update"][value="${grid}.+"]`);
        } else {
          $input = $(
            '.group [name="' +
              grid +
              '"] tbody tr:nth(' +
              row +
              ") " +
              focusstring
          );
          // Might've been the last row - then focus the butlast one
          if (!$input.length)
            $input = $(
              '.group [name="' +
                grid +
                '"] tbody tr:nth(' +
                (parseInt(row) - 1) +
                ") " +
                focusstring
            );
          // Empty table? Focus addbutton
          if (!$input.length)
            $input = $(`.group [name="update"][value="${grid}.+"]`);
        }
        if ($input.length) {
          $input.trigger("focus");
        }
      } else {
        // focus was lost
        if (
          both(
            complement(propEq("_isUpdate", true)),
            complement(propEq("_direction", "update"))
          )(data) ||
          (Mode.get("a-keyboard-user") &&
            document.activeElement === document.body &&
            !returnfocus())
        ) {
          $(".group.selected").trigger("focus");
          const e_group = document.querySelector(".group.selected");
          if (e_group === null) return;
          e_group.focus();
          if (doScrollToSelected(conf)) {
            if (e_group.previousElementSibling) {
              e_group.scrollIntoView({
                behavior: window.matchMedia("(prefers-reduced-motion: reduce)")
                  .matches
                  ? "auto"
                  : "smooth"
              });
            }
          }
        }
      }
    }, 0);
    return;
  }
  if (data.models && (!data.cases || !data.cases.length)) {
    $(".bb-model-name:first").trigger("focus");
    $(".bb-model.selected .bb-model-name:first").trigger("focus");
    return;
  }
  if (data.cases) {
    $("#bb-cases tbody .bb-case .bb-case-name:first").trigger("focus");
    return;
  }
  $("form#bb-login input[name=username]").trigger("focus");
}

function setupFocusHandler(event, data) {
  if (data.uniqueid) {
    $(document).on("bb:finalHandleData", focusHandler);
    $(document).off("bb:finalHandleData", setupFocusHandler);
  }
}

$(document).on("bb:finalHandleData", setupFocusHandler);

function updateDynProps(fulldata, input) {
  var data = {
    groups: fulldata.groups
  };
  $(document).trigger("bb:willUpdate", fulldata);
  if (data && data.groups) {
    var group = data.groups.filter(function (group) {
      return group.current;
    })[0];
    let controls = sortControls(group.controls.slice(0), []);
    $(
      '.group [data-datatype^="datades:"], .group [data-type="label"]'
    ).updateControl(controls, input);
    Validation.setMode();
  }
  $(document).trigger("bb:hasUpdated", fulldata);
}

$(document).on("bb:updated", function (event, $widget, control, updates) {
  if (updates.indexOf("visible") > -1 && control.identifier) {
    var $parent = $widget.parents(".bb-questionlabelgroup");
    if (control.visible) {
      $parent.attr("data-visible", control.visible);
      window.setTimeout(function () {
        $parent.removeAttr("hidden").attr("data-visible", control.visible);
      }, 80);
    } else {
      $parent.attr("data-visible", control.visible);
      window.setTimeout(function () {
        $parent.attr("hidden", true);
      }, 80);
    }
  }
});

/*** DATA HANDLERS END ***/

/*** VALIDATION BEGIN ***/

/**
 * @Class Validation object.
 *
 */
var Validation = {
  /**
   * @member @private {Array<Element>} Stack of to-be-validated elemenents
   */
  _stack: [],
  /**
   * @member {Function}
   * @return undefined
   */
  reset: function () {
    this._stack = [];
  },
  /**
   * @member {Function}
   * @return {Element} Next Element eligible for validation
   */
  next: function () {
    return this._stack.pop();
  },
  /**
   * @member {Function}
   * @param {Element} el Element we want to be validated in due time
   */
  add: function (el) {
    this._stack.push(el);
  }
};

/**
 * Are all inputs valid?
 * @return {Boolean} Whether all inputs pass the test
 */
Validation.allValid = function () {
  return (
    $.grep(
      $(
        '.group:not([disabled]) .validatable, .group:not([disabled]) [data-datatype^="datades:"]'
      )
        .validate({ silent: true })
        .map(function () {
          return $(this).data("validated");
        }),
      function (val) {
        return val === false;
      }
    ).length === 0
  );
};

/**
 * Update isValidated Mode
 * @return undefined
 */
Validation.setMode = function () {
  Mode.toggle("isValidated", Validation.allValid());
};

/**
 * Live Validation instructions
 */
$(document).on("keyup change", "body.hasModel", Validation.setMode);

// Push the input just left onto the validation stack
$(document).on("focusout", "#bb-q .group .validatable", function () {
  var me = $(this);
  Validation.add(me[0]);
});

$.fn.extend({
  geterrorelt: function () {
    var $this = $(this);
    return $this.data("$error") || $();
  },
  showValidation: function (options, ok, error) {
    var $this = $(this),
      node = $this.get(0);

    var errortext;
    if (error instanceof Error) errortext = error.message;
    else errortext = error;

    if (!document.body.contains(node)) {
      // console.log('Trying to validate unconnected', this)
      return;
    }
    $this.data("validated", ok);

    if (!ok) {
      var $error = $this.geterrorelt(),
        $anchor = $this.is("input[type=checkbox]")
          ? $this.next()
          : $this.data("anchor");

      $this.attr("aria-invalid", true);

      if ($error.length === 0) {
        if (!options.silent && !options.justhide) {
          $error = $(
            `<strong id="${$this.attr("id")}--error" class="errortext" aria-atomic="true" role="alert"></strong>`
          );
          $this.data("$error", $error);
        }
      }
      // If there was already an error element, and the input is
      // still invalid but (reason and therefore) the errortext
      // has changed, change the error text shown to the user.
      if ($error.length > 0) {
        if ($error.data("lasterrortext") !== errortext) {
          $error.data("lasterrortext", errortext);
          $error.text(errortext);
        }
      }
      if (!options.silent && !options.justhide) {
        $this.addClass("error invalid");
        // (re-)attach $error.
        $anchor.after($error);
        // This may be necessary:
        $("#bb-wrapmodel").scrollTo($error);
        // Allow complicated widgets to fix stuff afterwards
        $this.trigger("bb:errorOn", [errortext, $anchor, $error]);
      }
    } else {
      $this.attr("aria-invalid", false);
      $this.geterrorelt().remove();
      $this.removeClass("error invalid");
      $this.addClass("validated");
      // Allow complicated widgets to fix stuff afterwards
      $this.trigger("bb:errorOff");

      if (!options.silent && options.requestUpdate) {
        if (Mode.get("hasDynamicInterfaces")) {
          requestDynProps(node);
        }
      }
    }
  },
  // Validate input
  // OPTIONS: silent, justhide
  validate: function (options) {
    if (!options) {
      options = {};
    }
    if (options.silent === undefined) {
      options.silent = false;
    }
    if (options.justhide === undefined) {
      options.justhide = false;
    }
    // requestUpdate needs to be false whenever validation is done
    // upon node navigation (next, skip), in order to avoid useless
    // server requests. Also, on validating for just showing errors
    // on tabbing away, we want not to request an update - that is
    // already taken care of by the onChange event
    if (options.requestUpdate === undefined) {
      options.requestUpdate = true;
    }

    // Argument noui says: do not update the ui (i.e. do not show nor hide any errors).
    return $(this).each(function () {
      var $this = $(this),
        ok = true,
        errortext;

      try {
        // Let actual validation be performed by other method.
        ok = validateInput($this);
      } catch (err) {
        ok = false;
        errortext = err;
      }

      return $this.showValidation(options, ok, errortext);
    });
  }
});

// Check when tabbing / clicking to new input - we want to show
// validation while tabbing through, but not tabbing. onChange we want
// to hide validation errors, but not show them immediately.
$(document).on("focusin", ":input", function () {
  let validatable;
  while ((validatable = Validation.next())) {
    validatable = $(validatable);
    if ($(this).is(":radio")) {
      //Only validate when really outside of the radiogroup
      if (!$(this).parent(".radiogroup").has(validatable))
        validatable.validate({ requestUpdate: false });
    } else {
      if (validatable.get(0) != $(this).get(0))
        validatable.validate({ requestUpdate: false });
    }
  }
});

$(document).on(
  "change",
  "#bb-q .group.selected :input:not(button)",
  function () {
    var $this = $(this),
      options = { silent: false, justhide: true };
    if ($this.is(":radio")) {
      // validating radio???
      $this.parents(".radiogroup").validate(options);
    } else {
      $this.validate(options);
    }
  }
);

// Always check checkboxes onchange
$(document).on("change", "#bb-q .group :checkbox", function () {
  $(this).parents(".checklist").validate();
});

function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    var later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    window.clearTimeout(timeout);
    timeout = window.setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

const eltControltype = compose(prop("controltype"), getControl);

const doChangeOnKeyDown = elt => {
  const setting = path(["arbitrary", "core", "update-on-typing"])(conf);
  return (
    setting === "always" ||
    (setting instanceof Array && includes(eltControltype(elt), setting))
  );
};

function keyDown() {
  if (doChangeOnKeyDown(this)) $(this).data("valBefore", $(this).val());
}

$(document).on(
  "keydown",
  "#bb-q .group.selected :input:not(button)",
  debounce(keyDown, 32, true)
);

$(document).on(
  "keyup",
  "#bb-q .group.selected :input:not(button)",
  function () {
    if (doChangeOnKeyDown(this)) {
      var $this = $(this),
        before = $this.data("valBefore"),
        val = $this.val();
      if (before !== undefined && before !== val) {
        $this.trigger("change");
        $this.removeData("valBefore");
      }
    }
  }
);
/*** VALIDATION END ***/

/*** HINTS, TOOLTIPS BEGIN ***/
// Move to plugin core:tooltips
/*** HINTS, TOOLTIPS END ***/

/*** RENDERING 'ENGINE' BEGIN ***/
const doScrollToSelected = compose(
  val => val !== false,
  path(["arbitrary", "core", "scrollToSelectedGroup"])
);
const setDynamicMode = tap(
  group =>
    group.current && Mode.toggle("hasDynamicInterfaces", Boolean(group.dynamic))
);

/**
 * Render questions / labels (i.o.w. the main interaction
 * interface) This function is only called when there are actually
 * screens in need of rendering. Therefore, it need not check the JSON
 * object
 *
 * @param ev {Event} The event that triggered this function
 * @param data {Object} 'JSON'-object conforming to BB JSON API.
 */
function renderGroups(ev, data) {
  // Save previous id
  var previd = $("#bb-q" + " .group.selected").data("groupid"),
    groups = data.groups,
    $bbq = $("#bb-q");

  // Begin -- Only update what is new or was .selected before! There
  // is a problem with $.ajax calls when fast-clicking => therefore
  // step has {async: false}
  //
  // FIXME: when user press next, while
  // there is no next, a node too many is inserted. This can be
  // fixed now the server passes along the node id of a group.

  groups.forEach(setGroupTitle);
  if (!["open", "exit"].includes(Ajax.direction) && mustUpdate(conf)) {
    // Prepare DOM -- remove unneeded or to be re-rendered .groups
    for (let group of document.querySelectorAll(".group")) {
      if (complement(any(propEq("groupid", group.dataset["gid"])))(groups)) {
        // Remove a group if not in response
        group.parentNode.removeChild(group);
      } else if (Ajax.row && group.dataset["gid"] === Ajax.groupid) {
        // When adding/deleting rows, safe the space where the group
        // was (entire group will be re-rendered)
        const gob = find(propEq("groupid", group.dataset["gid"]))(groups);
        const tempNode = document.createComment("group");
        group.parentNode.replaceChild(tempNode, group);
        gob._tempNode = tempNode;
      }
    }
    compose(
      map(
        compose(
          ifElse(
            ({ groupid }) =>
              document.querySelector(`.group[data-gid="${groupid}"]`),
            group => {
              updateDynProps({
                groups: [{ current: true, controls: group.controls }]
              });
              const elt = document.querySelector(
                `.group[data-gid="${group.groupid}"]`
              );
              setSelectedStateAttributes(elt, group);
            },
            renderGroup
          ),
          setDynamicMode
        )
      ),
      sortGroups
    )(groups);
  } else {
    // Always remove .selected:
    $(".group.selected", $bbq).remove();
    if (Ajax.direction == "next" && groups.length > 1) {
      // Re-render only previous group and current group
      groups = groups.filter(function (group) {
        return group.current || group.groupid === previd;
      });
    } else if (
      Ajax.direction == "prior" &&
      $("#bb-q .group").length > 0 &&
      groups.length > 1
    ) {
      // Re-render only current group
      groups = groups.filter(function (group) {
        return group.current;
      });
    } else $bbq.empty();
    // End -- Only update what is new!

    $bbq.hide();
    compose(map(compose(renderGroup, setDynamicMode)), sortGroups)(groups);
  }
  $bbq.attr("lang", data.modellanguage).show();

  // Old questionlabelgroup plugin:
  if (!doGrouping(conf)) {
    (bb.questionlabelgroup || questionlabelgroup)();

    $('.bb-questionlabelgroup:has([data-datatype][data-visible="false"])').attr(
      {
        "data-visible": false,
        "hidden": true
      }
    );
  }
}

function sortGroups(groups) {
  // Fix insertion order
  return groups.sort(function (a, b) {
    return a.order - b.order;
  });
}

function sortControls(a, b) {
  if (!a[0]) return b.reverse();
  var ac = a.shift(),
    bc = b[0];
  if (
    bc &&
    ac.controltype === "label" &&
    !ac.datatype && // Label with a datatype is a text interface
    bc._sorted === undefined &&
    bc.controltype !== "label" &&
    (bc.controltype !== "linklabel" || bc.isreport) &&
    bc.controltype !== "checkbox"
  ) {
    // Reverse input with label
    b.shift();
    bc._sorted = true; // Instruct next recursion not to touch the control
    if (has("notnull", bc)) ac.isForNotNull = bc.notnull;
    if (has("readonly", bc)) ac.readonly = bc.readonly;
    ac.dynamic = bc.dynamic = /^datades:/.test(bc.datatype);
    ac.metadata = Object.assign({}, bc.metadata, ac.metadata);
    bc.meta = bc.meta || {}; // Associate input with label
    bc.meta.label = (ac.value || "").trim();
    bc.aria = bc.aria || {}; // Associate input with label
    if (bc.notnull) bc.aria.required = true;
    if (ac.notnull) ac.aria.required = true;
    // Associate input (group) with label.
    if (
      ["radio", "checkmultilist", "listbox", "multilist"].includes(
        bc.controltype
      )
    ) {
      if (bb.conf.a11y.optionfieldsets) {
        ac.controltype = "legend";
        ac.className = "bb-label";
      } else {
        bc.aria.labelledby = ac.id;
      }
    } else if (bc.controltype === "grid") {
      if (bb.conf.a11y.captions) {
        ac.controltype = "caption";
        bc.caption = ac;
      } else {
        bc.aria.labelledby = ac.id;
      }
    } else {
      ac.isFor = bc.id;
    }
    return sortControls(a, [bc, ac].concat(b));
  } else {
    if (
      bc &&
      ac.controltype === "label" &&
      !ac.datatype && // Label with a datatype is a text interface
      bc.controltype === "checkbox"
    ) {
      ac.isFor = bc.id; // Associate label with checkbox (that comes before)
      if (has("notnull", bc)) ac.isForNotNull = bc.notnull;
      if (has("readonly", bc)) ac.readonly = bc.readonly;
      ac.dynamic = /^datades:/.test(bc.datatype);
      ac.metadata = Object.assign({}, bc.metadata, ac.metadata);
      bc.meta = bc.meta || {}; // Associate input with label
      bc.meta.label = (ac.value || "").trim();
      bc.aria = bc.aria || {};
      if (bc.notnull) bc.aria.required = true;
      if (ac.notnull) ac.aria.required = true;
    }
    return sortControls(a, [ac].concat(b));
  }
}

function setGroupTitle(group) {
  var controls = group.controls;
  //  It's a title, if:
  //  there are two  1st is label                           Not a 'text' interface   1st doesnt control any
  if (
    controls[1] &&
    controls[0].controltype === "label" &&
    !controls[0].datatype &&
    !controls[0].isfor
  ) {
    controls[0].controltype = "legend";
    group.screentitle = controls[0].value;
  }
}

const setSelectedStateAttributes = (elt, group) => {
  elt.classList.toggle("selected", group.current);
  elt.classList.toggle("unselected", !group.current);
  if (group.current || canEditEarlier(conf)) {
    elt.removeAttribute("aria-hidden");
    elt.removeAttribute("disabled");
  } else {
    elt.setAttribute("aria-hidden", true);
    elt.setAttribute("disabled", "disabled");
  }
};

const hasStatusRole = pathEq(["metadata", "role"], "status");

function renderGroup(group) {
  var controls = group.controls,
    wGroup = $(
      '<fieldset class="group" ' +
        (hasStatusRole(group) ? 'role="status"' : 'tabindex="-1"') +
        (group.aria && group.aria.describedby
          ? ' aria-describedby="' + group.aria.describedby + '"'
          : "") +
        "></fieldset>"
    );

  // If this has a dupe, first remove the old one:
  $(".group").each(function () {
    if ($(this).data("groupid") === group.groupid) $(this).remove();
  });

  const elt = wGroup.get(0);
  elt.dataset["gid"] = group["groupid"];
  wGroup.data("groupid", group["groupid"]);

  controls = sortControls(controls.slice(0), []);

  if (doGrouping(conf)) controls = groupOuter(controls);

  $(controls).each(function (i, c) {
    if (doGrouping(conf)) {
      elt.appendChild(createFormGroup(wControl, group, 1)(c));
    } else wControl(c, group, elt);
  });

  elt.classList.add("bb-screenmode-" + group.screenmode);
  elt.setAttribute("data-node", group.name);
  if (!bb.getVar("wrongOrder")) elt.setAttribute("data-bb:order", group.order);

  setSelectedStateAttributes(elt, group);

  if (group._tempNode) {
    group._tempNode.parentNode.replaceChild(elt, group._tempNode);
    delete group._tempNode;
  } else {
    if (group.screenmode == "addtop") $("#bb-q").prepend(elt);
    else $("#bb-q").append(elt);
  }
}

/**
 * Wrap questions + accompanying labels in a single group
 *
 * This function may be overriden by assigning a function to <tt>bb.questionlabelgroup</tt>
 * @see Plugin questionlabelgroup-ng
 *
 * @return undefined
 */
function questionlabelgroup() {
  $(".group:not(:has(.bb-questionlabelgroup))>.bb-label").each(function () {
    var $this = $(this);
    var input = $this.next(
      ":not(label):not(a):not([type=checkbox]):not(img):not(.clearfix)"
    );
    var itype = input.data("type");
    var questionandlabel = $this.add(input);

    if (questionandlabel.length > 1)
      questionandlabel.wrapAll(
        '<div class="bb-questionlabelgroup bb-itype-' + itype + '"></div>'
      );
    else {
      questionandlabel = $this.prev("[type=checkbox]").add(this);
      if (questionandlabel.length > 1)
        questionandlabel.wrapAll(
          '<div class="bb-questionlabelgroup bb-itype-checkbox"></div>'
        );
    }
    questionandlabel
      .parent(".bb-questionlabelgroup")
      .append('<div class="clearfix"></div>');
    $.each(
      questionandlabel.parent(".bb-questionlabelgroup").find("[data-type]"),
      function () {
        var $this = $(this);
        if ($this.attr("class")) {
          var classname = $this.attr("class").match(/\bbbm-[a-z0-9-]+\b/);
          if (classname) {
            classname = classname[0].replace(/\bbbm-/, "bb-g-");
            $this.parents(".bb-questionlabelgroup").addClass(classname);
          }
        }
      }
    );
  });
}

/*** RENDERING 'ENGINE' END ***/

/*** 'COMPLEX' WIDGET BEHAVIOUR BEGIN ***/

/**
 * Radiogroup and checklist enhancements
 */

$(document)
  .on("change programmatically-changed", ".bb-option", function (ev) {
    var $this = $(this);
    $this.toggleClass("checked", ev.target.checked);
    if (ev.target.type === "radio" && ev.target.checked) {
      $this.siblings().removeClass("checked");
    }
  })
  .on("focus", ".bb-option", function (ev) {
    $(this).addClass("focus");
    if (ev.target.type === "radio") {
      ev.preventDefault();
      ev.stopImmediatePropagation();
      return false;
    }
    return true;
  })
  .on("blur", ".bb-option", function () {
    $(this).removeClass("focus");
  })
  .on(
    "keydown",
    ".radiogroup .bb-option",
    // Fix the odd default behaviour of selecting upon focus
    function (ev) {
      var $other,
        chars = [37, 38, 39, 40],
        //           left, up, right, down
        idx = chars.indexOf(ev.keyCode);
      if (idx === -1) return true;

      $other =
        idx < 2 // 'prev' chars
          ? $(this).prev().find('input[type="radio"]')
          : $(this).next().find('input[type="radio"]');

      // At beginning or end... go around (Edge selects otherwise...).
      if (!$other.length) {
        $other =
          idx < 2 // 'prev' chars
            ? $(this).siblings().last().find('input[type="radio"]')
            : $(this).siblings().first().find('input[type="radio"]');
      }
      if ($other.length) {
        $other.trigger("focus");
        ev.preventDefault();
        ev.stopImmediatePropagation();
        return false;
      }
      return true;
    }
  );

/*** 'COMPLEX' WIDGET BEHAVIOUR END ***/

/*** LINKS BEGIN ***/

/**
 * Original code moved to plugin rewrite-links
 *
 */

/*** LINKS END ***/

/*** TOKENCHANNEL BEGIN ***/

$(document).on("bb:preHandleData", (_, data) => {
  if (has("uniqueid", data)) {
    token.setToken(prop("uniqueid", data));
  }
});

$(document).on("bb:preHandleData", (_, data) => {
  // document.body.dispatchEvent(new customEvent("bb:storeToken", { bubbles: true, })
  if (has("uniqueid", data)) {
    token.setToken(prop("uniqueid", data));
  }
});

$(document).on("bb:mode:isLoggedIn", (_event, bool) => {
  if (!bool) {
    token
      .getHash()
      .then(tokenHash => token.postMessage({ tokenHash, type: "loggedOut" }));
  }
});

token.addEventListener("message", message => {
  token.getHash().then(hash => {
    if (message.data.tokenHash === hash) {
      if (message.data.type === "loggedOut") window.close() || logout();
    }
  });
});

/*** TOKENCHANNEL END ***/

/*** EXPORTS BEGIN ***/

bb.escapeHTML = escapeHTML;
bb.exit = exit;
bb.deleteCase = deleteCase;
bb.logout = logout;
bb.menu = menu;

bb.authenticate = token => Vars.setVars({ uniqueid: token });
bb.newcase = newcase;
bb.step = step;
bb.restart = function restart() {
  newcase(Vars.getVar("dbname"));
};
bb.rewind = function rewind(cb, options) {
  step("rewind", cb, options);
};
bb.update = function update(cb, options) {
  step("update", cb, options);
};
bb.updatemis = function updatemis(options) {
  step("updatemis", $.noop, options);
};
bb.next = function next(cb, options) {
  step("next", cb, options);
};
bb.prior = function prior(cb, options) {
  step("prior", cb, options);
};
bb.skip = function skip(cb, options) {
  step("skip", cb, options);
};
bb.gotonode = function gotonode(groupid, cb, options = null) {
  step("gotonode", cb, Object.assign({}, { groupid }, options));
};
bb.runtonode = function runtonode(nodename, cb) {
  step("runtonode", cb, { fullnodename: nodename });
};
bb.getVar = Vars.getVar;
bb.notify = notify.bind(null, {});
bb.ajax = {
  replace: Ajax.replace,
  busy: function () {
    return Ajax.busy;
  },
  release: Ajax.release,
  post: Ajax.post,
  direction: function () {
    return Ajax.direction;
  }
};
bb.URL = urlutils;
bb.Numerals = Numerals;
bb.Plugins = bb.Plugins || {};
bb.Validation = Validation;
bb.positionalFormat = positionalFormat;
bb.humanDate = humanDate;
bb.propFinder = propFinder;
bb.requestDynProps = requestDynProps;
// Window-export some stuff used in bookmarklets.
window.bb = {
  restart: bb.restart,
  getVar: bb.getVar,
  requestDynProps: bb.requestDynProps,
  Mode,
  menu
};

/*** EXPORTS END ***/

export { bb, _, _ as gt };
